/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessExplainResourceAccess } from "../funcs/accessExplainResourceAccess.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ExplainResourceAccessResult } from "../models/components/explainresourceaccessresult.js";
import {
  ExplainResourceAccessRequest,
  ExplainResourceAccessSecurity,
  ResourceKind,
} from "../models/operations/explainresourceaccess.js";
import { unwrapAsync } from "../types/fp.js";
export type ExplainResourceAccessQueryData = ExplainResourceAccessResult;

export function prefetchExplainResourceAccess(
  queryClient: QueryClient,
  client$: GramCore,
  request: ExplainResourceAccessRequest,
  security?: ExplainResourceAccessSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildExplainResourceAccessQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildExplainResourceAccessQuery(
  client$: GramCore,
  request: ExplainResourceAccessRequest,
  security?: ExplainResourceAccessSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ExplainResourceAccessQueryData>;
} {
  return {
    queryKey: queryKeyExplainResourceAccess({
      resourceKind: request.resourceKind,
      resourceId: request.resourceId,
      userId: request.userId,
      gramSession: request.gramSession,
    }),
    queryFn: async function explainResourceAccessQueryFn(
      ctx,
    ): Promise<ExplainResourceAccessQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessExplainResourceAccess(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyExplainResourceAccess(
  parameters: {
    resourceKind: ResourceKind;
    resourceId: string;
    userId: string;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "explainResourceAccess", parameters];
}
